import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const one = (
      <p>
        Students currently experience frustration with the lack of transparency and communication in the facilities request process. Many encounter delays, miscommunications, and the inconvenience of multiple platforms. RepairNet addresses these pain points by centralizing the request process, providing timely notifications, and improving communication between students and facilities teams.

      </p>
    );
    const two = (
      <p>
        Our Vision is to streamlines interaction between students and the facilities department by leveraging the university’s existing infrastructure which is the Housing Portal.
      </p>
    );

    const tech_stack = [
      "Single Sign-On Integration ",
      "Facilities Request Submission",
      "Request Tracking Dashboard",
      "Notifications and Alerts",
      "Feedback Mechanism",
      "Admin Portal for Facilities Team"
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">/about repairnet</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              {"Top Features of RepairNet:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li style={{ marginLeft: "20px" }}>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default About;
